<script setup lang="ts">
const { menu, items, toggle } = usePanelAvatar();

const avatarDt = {
  root: {
    width: "2.25rem",
    height: "2.25rem",
  },
};

const { isUser, data: user } = useUser();

const initials = computed(() => {
  if (isUser.value) {
    return `${user.value!.first_name[0]}${user.value!.last_name[0]}`;
  }
  return "";
});
</script>

<template>
  <div class="card flex justify-center">
    <PrimeAvatar
      :dt="avatarDt"
      class="cursor-pointer bg-cyan-600 font-semibold"
      shape="circle"
      :label="initials"
      style="width: 2.25rem; height: 2.25rem"
      @click="toggle"
    />
    <PrimeMenu ref="menu" :model="items" :popup="true" class="font-semibold">
      <template #item="{ item, props }">
        <NuxtLink
          v-if="item.route"
          v-slot="{ href, navigate }"
          :to="item.route"
        >
          <a v-ripple :href="href" v-bind="props.action" @click="navigate">
            <span :class="item.icon" />
            <span class="ml-2">{{ item.label }}</span>
          </a>
        </NuxtLink>
        <a v-else v-ripple v-bind="props.action">
          <span :class="item.icon" />
          <span class="ml-2">{{ item.label }}</span>
        </a>
      </template>
    </PrimeMenu>
  </div>
</template>
